import * as React from "react";
const SvgAlertWarning = props => <svg width="1em" height="1em" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15 15H0L7.5 0 15 15Zm-7-3H7v1h1v-1Zm0-1V6H7v5h1Z" fill="#FF9300" /></svg>;
export default SvgAlertWarning;